import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import {
  Form,
  Col,
  Button,
  Spinner,
  OverlayTrigger,
  Tooltip,
} from 'react-bootstrap';
import { AppContext } from '../../App';
import MailService from '../../services/MailService';

const Contact = () => {
  const { showNotification, errorNotification } = React.useContext(AppContext);
  const [mailService] = useState(new MailService());

  const [submitLoading, setSubmitLoading] = useState(false);

  const allowedExtensions = ['jpg', 'jpeg', 'png', 'rar', 'zip'];
  const nameHasExtension = (str) => {
    return allowedExtensions.some((element) => {
      if (str.includes(element)) {
        return true;
      }

      return false;
    });
  };

  const validationSchema = Yup.object().shape({
    name: Yup.string()
      .required('Name is required')
      .matches(/^.{3,}$/i, 'Name must be at least 3 letters'),
    email: Yup.string()
      .required('Email is required')
      .email('Email is not valid'),
    subject: Yup.string()
      .required('Subject is required')
      .matches(/^.{3,}$/i, 'Subject must be at least 3 letters'),
    message: Yup.string().required('Message is required'),
  });

  const onSubmit = async (values) => {
    var formData = new FormData();
    formData.append('Name', values.name);
    formData.append('EmailAddress', values.email);
    formData.append('Subject', values.subject);
    formData.append('Body', values.message.replace(/\n/g, '<br />'));
    if (values.attachment.length) {
      const attachment = values.attachment[0];
      if (attachment.size > 25 * 1048576) {
        setError('attachment', {
          type: 'custom',
          message: 'attachment max size is 25MB',
        });
        return;
      }
      if (!nameHasExtension(attachment.name.split('.').pop())) {
        setError('attachment', {
          type: 'custom',
          message: 'attachment file type not allowed',
        });
        return;
      }
      formData.append('Attachment', values.attachment[0]);
    }
    setSubmitLoading(true);
    mailService
      .SendMail(formData)
      .then((result) => {
        if (result.success) {
          showNotification(
            'success',
            'Mail sent successfully',
            10,
            'Mail sent'
          );
          clearErrors();
          reset();
        } else {
          showNotification(
            'error',
            'Error while sending mail',
            10,
            'Error sending mail'
          );
        }
      })
      .catch((error) => {
        errorNotification(error, 'Error sending mail');
      })
      .finally(() => {
        setSubmitLoading(false);
      });
  };

  const formOptions = { resolver: yupResolver(validationSchema) };
  const {
    register,
    handleSubmit,
    clearErrors,
    setError,
    reset,
    formState: { errors },
  } = useForm(formOptions);

  return (
    <main id="main">
      <br />
      <br />
      <br />
      <section id="contact" className="contact">
        <div className="container">
          <div className="section-title">
            <span>Contact</span>
            <h2>Contact</h2>
            <p>
              For 3D printing and CNC machining inquiry for quatation please
              attach your 3D model on the contact form in .zip or .rar extension
            </p>
          </div>

          <div className="row">
            <div className="col-lg-5 d-flex align-items-stretch">
              <div className="info">
                <div className="address">
                  <i className="bi bi-geo-alt"></i>
                  <h4>Location:</h4>
                  <p>Bitola, NR Macedonia</p>
                </div>

                <div className="email">
                  <i className="bi bi-envelope"></i>
                  <h4>Email:</h4>
                  <p>
                    <a href="mailto: jovanovskiLaboratory@gmail.com">
                      jovanovskiLaboratory@gmail.com
                    </a>
                  </p>
                </div>

                <div className="phone">
                  <i className="bi bi-phone"></i>
                  <h4>Call:</h4>
                  <p>+389 75 926891</p>
                </div>
                <div className="phone">
                  <i className="bi bi-phone"></i>
                  <h4>Call:</h4>
                  <p>+389 71 479217</p>
                </div>
              </div>
            </div>

            <div className="col-lg-7 mt-5 mt-lg-0 d-flex align-items-stretch">
              <Form
                className="php-email-form"
                onSubmit={handleSubmit(onSubmit)}
              >
                <div className="row">
                  <Form.Group as={Col} md={6}>
                    <Form.Label htmlFor="name" className="form-label">
                      Your Name
                    </Form.Label>
                    <Form.Control
                      id="name"
                      name="name"
                      type="text"
                      {...register('name')}
                      placeholder=""
                      isInvalid={!!errors.name}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.name?.message}
                    </Form.Control.Feedback>
                  </Form.Group>
                  <Form.Group as={Col} md={6}>
                    <Form.Label htmlFor="email" className="form-label">
                      Your Email
                    </Form.Label>
                    <Form.Control
                      id="email"
                      name="email"
                      type="text"
                      {...register('email')}
                      placeholder=""
                      isInvalid={!!errors.email}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.email?.message}
                    </Form.Control.Feedback>
                  </Form.Group>
                </div>
                <Form.Group className="mt-3">
                  <Form.Label htmlFor="subject" className="form-label">
                    Subject
                  </Form.Label>
                  <Form.Control
                    id="subject"
                    name="subject"
                    type="text"
                    {...register('subject')}
                    placeholder=""
                    isInvalid={!!errors.subject}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.subject?.message}
                  </Form.Control.Feedback>
                </Form.Group>

                <Form.Group className="mt-3">
                  <Form.Label htmlFor="message" className="form-label">
                    Message
                  </Form.Label>
                  <Form.Control
                    id="message"
                    name="message"
                    as="textarea"
                    rows="10"
                    {...register('message')}
                    placeholder=""
                    isInvalid={!!errors.message}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.message?.message}
                  </Form.Control.Feedback>
                </Form.Group>

                <Form.Group className="mt-3">
                  <Form.Label htmlFor="attachment" className="form-label">
                    Attachment{' '}
                    <OverlayTrigger
                      placement="right"
                      delay={{ show: 250, hide: 400 }}
                      overlay={(props) => (
                        <Tooltip id="button-tooltip" {...props}>
                          Maximum allowed size is 25MB
                          <br />
                          Allowed file extensions are:{' '}
                          {allowedExtensions.join(',')}
                          <br />
                          Please zip or rar any other types of files
                        </Tooltip>
                      )}
                    >
                      <span>
                        <i className="bi bi-info-circle"></i>
                      </span>
                    </OverlayTrigger>
                  </Form.Label>
                  <Form.Control
                    size="lg"
                    id="attachment"
                    name="attachment"
                    type="file"
                    {...register('attachment')}
                    isInvalid={!!errors.attachment}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.attachment?.message}
                  </Form.Control.Feedback>
                </Form.Group>

                <div className="text-center mt-4">
                  <Button disabled={submitLoading} type="submit">
                    {submitLoading ? (
                      <Spinner animation="grow" />
                    ) : (
                      <>Send Message</>
                    )}
                  </Button>
                </div>
              </Form>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default Contact;
